import { Link } from "react-router-dom";
import { LayoutDashboard, HeartPulse, Users, Bot, Radar, ClipboardCheck, Gavel, BadgeCheck } from "lucide-react";
import { useTranslation } from "../../../../i18n/useTranslation";

const PILLARS = [
  { Icon: LayoutDashboard, titleKey: "dashboardTitle", bodyKey: "dashboardBody" },
  { Icon: HeartPulse, titleKey: "lifeTitle", bodyKey: "lifeBody" },
  { Icon: Users, titleKey: "peopleTitle", bodyKey: "peopleBody" },
  { Icon: Bot, titleKey: "thingsTitle", bodyKey: "thingsBody" },
];

const LIFECYCLE = [
  { Icon: Radar, titleKey: "trackingTitle" },
  { Icon: ClipboardCheck, titleKey: "auditTitle" },
  { Icon: Gavel, titleKey: "governanceTitle" },
  { Icon: BadgeCheck, titleKey: "certificationTitle" },
];

const ItrustComingSoon = () => {
  const { t } = useTranslation();
  return (
    <div>
      {/* hero */}
      <div className="band-hero section text-center">
        <img src={require("../../../../img/web/market/itrust.png")} alt="" className="w-16 h-16 mx-auto mb-4" />
        <span className="tag-coming-soon">{t("itrustComingSoon.badge")}</span>
        <h1 className="pt-3">iTrust.ID</h1>
        <div className="max-w-xl mx-auto pt-3">
          <p className="mini">{t("itrustComingSoon.intro1")}</p>
        </div>
      </div>

      {/* problem */}
      <div className="band-a section-tight text-center">
        <div className="eyebrow">{t("itrustComingSoon.problemEyebrow")}</div>
        <h2>{t("itrustComingSoon.problemHeading")}</h2>
        <div className="max-w-xl mx-auto pt-2">
          <p className="mini">{t("itrustComingSoon.problemBody")}</p>
        </div>
      </div>

      {/* four pillars */}
      <div className="band-b section-tight">
        <div className="max-w-xl mx-auto text-center">
          <div className="eyebrow">{t("itrustComingSoon.pillarsEyebrow")}</div>
          <h2>{t("itrustComingSoon.pillarsHeading")}</h2>
        </div>
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 px-5 py-8">
          {PILLARS.map(({ Icon, titleKey, bodyKey }) => (
            <div key={titleKey} className="card-ledger text-left flex gap-5 items-start">
              <Icon size={32} strokeWidth={1.5} style={{ color: "var(--gold)" }} className="shrink-0" />
              <div>
                <h3>{t(`itrustComingSoon.${titleKey}`)}</h3>
                <p className="mini pt-1">{t(`itrustComingSoon.${bodyKey}`)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* trust lifecycle */}
      <div className="band-a section-tight text-center">
        <div className="eyebrow">{t("itrustComingSoon.lifecycleEyebrow")}</div>
        <h2>{t("itrustComingSoon.lifecycleHeading")}</h2>
        <div className="max-w-xl mx-auto pt-2">
          <p className="mini">{t("itrustComingSoon.lifecycleBody")}</p>
        </div>
        <div className="max-w-3xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 px-5 py-8">
          {LIFECYCLE.map(({ Icon, titleKey }) => (
            <div key={titleKey} className="card-ledger text-center">
              <Icon className="mx-auto" size={32} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
              <h4 className="pt-2">{t(`itrustComingSoon.${titleKey}`)}</h4>
            </div>
          ))}
        </div>
      </div>

      {/* closing */}
      <div className="band-b section-tight text-center">
        <div className="max-w-md mx-auto">
          <p className="mini">{t("itrustComingSoon.intro2")}</p>
        </div>
        <div className="pt-6 flex gap-4 justify-center flex-wrap">
          <Link to="/solutions/deviceworks" className="btn-outline">{t("itrustComingSoon.btnDeviceWorks")}</Link>
          <Link to="/solutions" className="btn-brass">{t("itrustComingSoon.btnBackSolutions")}</Link>
        </div>
      </div>
    </div>
  );
};

export default ItrustComingSoon;
